import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import {
  AcademyTopicInput,
  useUpdateAcademyTopicMutation,
} from 'features/classCreation';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';

export default function EditAcademyTopicForm({
  academyTopic,
  isEditing,
  setIsEditing,
}) {
  const [topic, setTopic] = useState(academyTopic);
  const [
    updateAcademyTopic,
    { isSuccess, error, isLoading: isUpdating, reset },
  ] = useUpdateAcademyTopicMutation();

  useEffect(() => {
    if (!isEditing) {
      setTopic(academyTopic);
      if (error) {
        reset();
      }
    }
  }, [academyTopic, error, isEditing, reset]);

  const handleAcademyTopicChange = useCallback((newTopic) => {
    setTopic(newTopic);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Class template is updated successfully!');
      setIsEditing(false);
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in updating the class template. Please try again later!'
      );
    }
  }, [error, isSuccess, setIsEditing]);

  const handleAcademyTopicUpdate = useCallback(
    (e) => {
      e.preventDefault();
      updateAcademyTopic({
        academyTopicId: academyTopic.id,
        academyTopic: topic,
      });
    },
    [academyTopic.id, topic, updateAcademyTopic]
  );

  return (
    <Form onSubmit={handleAcademyTopicUpdate}>
      <AcademyTopicInput
        value={topic}
        disabled={!isEditing}
        onChange={handleAcademyTopicChange}
      />
      <FieldErrors
        name="title"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="junction_number"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="academy_module_id"
        errors={error?.data?.errors}
      />
      {isEditing && (
        <Tappable
          type="submit"
          disabled={isUpdating}
          className="btn btn-primary btn-long m-t-xs"
          onClick={handleAcademyTopicUpdate}
        >
          Update Class Template
        </Tappable>
      )}
    </Form>
  );
}
